import $ from 'jquery/src/jquery';
import 'isotope-layout/dist/isotope.pkgd';
import '@fancyapps/fancybox';
import "@fancyapps/fancybox/dist/jquery.fancybox.css";

$(document).ready(function ($) {

    $('.galleryListing').each(function (index, listingElement) {
        var $listing = $(listingElement);
        var $pagination = $listing.find('.galleryListing__pagination');
        var $itemsContainer = $listing.find('.galleryListing__items');
        var itemSelector = '.galleryListing__item';
        var step = window.outerWidth < 640 ? 5 : ( window.outerWidth < 1260 ? 10 : 10 );
        var visibleItemsNum = step;
        var matchCounter = 0;
        $itemsContainer.isotope({
            itemSelector: itemSelector,
            //layoutMode: 'fitRows',
            filter: isotopeFilter
        });

        function isotopeFilter() {
            matchCounter++;
            return matchCounter <= visibleItemsNum;
        }

        function showMoreItems() {
            visibleItemsNum = visibleItemsNum + step;
            matchCounter = 0;
            $itemsContainer.isotope();
            $pagination.toggle( matchCounter > visibleItemsNum );
        }

        $pagination.toggle( matchCounter > visibleItemsNum );

        $pagination.on( 'click', 'button', showMoreItems );
    });


    $('[data-fancybox="gallery"]').fancybox({
        infobar: false,
        toolbar: false,
        smallBtn: true,
        touch: false,
        buttons: [
            //"zoom",
            //"share",
            //"slideShow",
            //"fullScreen",
            //"download",
            //"thumbs",
            "close"
        ],
        btnTpl: {
            download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"></a>',
            zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"></button>',
            close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"></button>',
            arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"></button>',
            arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"></button>',
            smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"></button>'
        },
        mobile: {
            clickContent: function(current, event) {
                return current.type === "image" ? false : false;
            },
            clickSlide: function(current, event) {
                return current.type === "image" ? "close" : "close";
            },
        },
    });
});